export default {
  'component.sellerinformation.title': 'Selgers detaljer',
  'component.sellerinformation.sellerno': 'Selger ',
  'component.sellerinformation.propertyaddress': 'Eiendomsadresse',
  'component.sellerinformation.postcode': 'Postnummer',
};
